<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <!-- 搜索条件表单 -->
        <el-form :model="queryParams" ref="queryForm" size="small" label-width="100px">
          <!-- 第一行搜索条件 -->
          <el-row :gutter="24" type="flex">
            <el-col :span="5">
              <el-form-item label="使用单位">
                <el-input v-model="queryParams.useUntName" placeholder="请输入使用单位" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="上传状态">
                <el-select v-model="queryParams.uploadSuccess" placeholder="请选择上传状态" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="全部" :value="undefined"></el-option>
                  <el-option label="成功" value="1"></el-option>
                  <el-option label="失败" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="上传日期">
                <el-date-picker v-model="queryParams.uploadDateStr" type="date" placeholder="请选择上传日期" value-format="yyyy-MM-dd" clearable style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 操作按钮 - 使用权限按钮组件 -->
          <div style="text-align: center; margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" :disabledButtons="toolbarDisabledButtons" @handleQuery="handleQuery" @handleApply="handleApply" @statement="statement" @handleDeclarationDownloads="handleDeclarationDownloads" @handleDelete="handleDelete" />
          </div>

          <!-- 数据表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading"
                    element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" height="500" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" fixed="left"></el-table-column>
            <el-table-column type="index" label="序号" fixed="left" width="60" align="left" :index="indexMethod"></el-table-column>
            <el-table-column label="声明编号" align="left" prop="confNum" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用单位名称" align="left" prop="useUntName" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="台数" align="left" prop="eqpCount" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="识别码" align="left" prop="oidNos" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="是否上传成功" align="left" prop="uploadSuccess" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag :type="scope.row.uploadSuccess === '1' ? 'success' : 'danger'">
                  {{ scope.row.uploadSuccess === '1' ? '成功' : '失败' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="上传失败原因" align="left" prop="uploadFailReason" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="上传日期" align="left" prop="uploadDate" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.uploadDate ? scope.row.uploadDate.split(' ')[0] : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="上传人" align="left" prop="uploadPerson" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="left" width="200" fixed="right">
              <template slot-scope="{ row }">
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :disabledButtons="['handleDelete']" @DeclarationDownload="DeclarationDownload(row)" />
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 引入弹出层组件 -->
    <ConformanceDialog ref="conformanceDialog" @refresh="getList" />
    <GenerateDialog ref="generateDialog" @refresh="getList" />
  </div>
</template>

<script>
import ConformanceDialog from './Dialog.vue';
import GenerateDialog from './GenerateDialog.vue';
import { queryConformanceUploadRecordList, deleteConformanceUploadRecord, batchDownloadConformance } from '@/api/contract/contract';

export default {
  name: 'DeclarationofConformity',
  components: {
    ConformanceDialog,
    GenerateDialog
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 表格数据
      tableData: [],
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 10,
        useUntName: undefined, // 使用单位
        uploadSuccess: undefined, // 上传状态（1=成功，0=失败）
        uploadDateStr: undefined // 上传日期（yyyy-MM-dd）
      },
      selectedRows: []
    };
  },
  computed: {
    /** 无勾选时禁用工具栏批量删除 */
    toolbarDisabledButtons () {
      return this.selectedRows.length ? [] : ['handleDelete'];
    }
  },
  created () {
    this.getList();
  },
  activated () {
    // 如果该页面被 keep-alive 缓存，返回页面时 created 不会再次触发，这里补一次刷新
    this.getList();
  },
  methods: {
    /**
     * 计算序号（考虑分页）
     */
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1;
    },

    /**
     * 去除文件名非法字符（Windows 等）
     */
    sanitizeDeclarationFileName (str) {
      if (str == null || str === '') return '';
      return String(str).replace(/[\\/:*?"<>|]/g, '_').trim();
    },

    /**
     * 下载文件名主体：有小区则为「小区名称 + 使用单位」，无小区则为「使用单位」；
     * 多行时小区名称取第一个非空，使用单位取第一个非空。
     */
    buildDeclarationDownloadBaseName (rows) {
      const list = Array.isArray(rows) ? rows : [];
      const houseNameRaw = list.map(r => r && r.houseName).find(v => v != null && String(v).trim() !== '');
      const useUntNameRaw = list.map(r => r && r.useUntName).find(v => v != null && String(v).trim() !== '');
      const houseName = this.sanitizeDeclarationFileName(houseNameRaw);
      const useUntName = this.sanitizeDeclarationFileName(useUntNameRaw);
      let base = houseName ? `${houseName}${useUntName || ''}` : (useUntName || '');
      if (!base) {
        base = `符合性声明_${new Date().getTime()}`;
      }
      return base;
    },

    /**
     * 查询列表数据
     */
    getList () {
      this.loading = true;

      // 调用查询符合性声明上传记录列表的API
      queryConformanceUploadRecordList(this.queryParams).then(res => {
        // 处理返回数据
        let records = []
        let total = 0

        if (res && res.retCode === 'ok' && res.additionalData) {
          const pageData = res.additionalData
          // 新格式：PageData 对象
          if (pageData.dataList && Array.isArray(pageData.dataList)) {
            records = pageData.dataList
            total = pageData.totalRowNum || 0
            this.queryParams.currPage = pageData.curPage || this.queryParams.currPage
            this.queryParams.pageSize = pageData.pageSize || this.queryParams.pageSize
          }
          // 兼容旧格式：直接是数组
          else if (Array.isArray(pageData)) {
            records = pageData
            total = records.length
          }
        } else if (res && res.retCode !== undefined) {
          // 有标准返回结构，但没有数据
          this.$message.error(res.retMsg || '获取符合性声明上传记录列表失败')
        } else {
          // 无法识别的返回结构
          this.$message.error('获取符合性声明上传记录列表失败：返回数据格式不正确')
        }

        this.tableData = records
        this.total = total
        this.loading = false;
      }).catch(error => {
        console.error('获取符合性声明上传记录列表失败:', error);
        this.loading = false;
        this.$message.error('获取符合性声明上传记录列表失败');
      });
    },

    /**
     * 查询按钮
     */
    handleQuery () {
      this.queryParams.currPage = 1;
      this.getList();
    },

    /**
     * 状态调整按钮 - 打开状态调整弹窗
     */
    handleApply () {
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选列表数据后再进行状态调整');
        return;
      }
      this.$refs.conformanceDialog.openDialog('status', null, this.selectedRows);
    },
    /**
     * 生成声明按钮 - 打开生成声明弹窗
     */
    statement () {
      this.$refs.generateDialog.openDialog();
    },
    /**
     * 修改按钮 - 打开修改弹窗
     * @param {Object} row - 当前行数据
     */
    handleEdit (row) {
      this.$refs.conformanceDialog.openDialog('edit', row, []);
    },
    /**
     * 声明下载按钮 - 打开声明下载弹窗
     */
    DeclarationDownload (row) {
      // 检查是否存在文件UUID
      if (!row.fileUUID) {
        this.$message.warning('该记录没有符合性申明文件');
        return;
      }

      this.$message.info('正在下载符合性申明...');

      try {
        // 构建下载URL（根据PdfImgViewer组件的逻辑，文件路径为 /api/pdf/文件名）
        const downloadUrl = `/api/pdf/${row.fileUUID}`;

        const fileBase = this.buildDeclarationDownloadBaseName([row]);
        // 创建隐藏的a标签进行下载
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${fileBase}.pdf`;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('下载成功');
      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('下载失败，请重试');
      }
    },
    /**
     * 批量声明下载按钮 
     */
    handleDeclarationDownloads () {
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选需要下载的数据');
        return;
      }

      const confNums = [...new Set(this.selectedRows.map(item => item.confNum).filter(Boolean))];
      if (!confNums.length) {
        this.$message.warning('勾选数据中未找到声明编号，无法下载');
        return;
      }

      batchDownloadConformance({ confNums }).then(blob => {
        if (!blob || blob.size === 0) {
          this.$message.error('下载失败：未获取到文件');
          return;
        }

        const fileName = `${this.buildDeclarationDownloadBaseName(this.selectedRows)}.zip`;
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        this.$message.success('批量下载已开始');
      }).catch(error => {
        console.error('批量下载符合性声明失败:', error);
        this.$message.error('批量下载失败，请稍后重试');
      });
    },

    handleSelectionChange (rows) {
      this.selectedRows = rows;
    },

    /**
     * 批量删除：删除勾选的列表数据，接口传入 uploadRecordPids
     */
    handleDelete () {
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选需要删除的数据');
        return;
      }

      const rowsWithoutPid = this.selectedRows.filter(r => r.uploadRecordPid == null || r.uploadRecordPid === '');
      if (rowsWithoutPid.length) {
        this.$message.warning('勾选的数据中存在缺少上传记录主键的记录，无法删除，请重新勾选');
        return;
      }

      const uploadRecordPids = [...new Set(this.selectedRows.map(r => r.uploadRecordPid))];
      const message = `确定要删除选中的 ${this.selectedRows.length} 条符合性声明上传记录吗？删除后将同时删除关联的符合性声明。`;

      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteConformanceUploadRecord({ uploadRecordPids }).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success(res.retMsg || '删除成功');
            this.getList();
          } else {
            this.$message.error((res && res.retMsg) || '删除失败');
          }
        }).catch(error => {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    /**
     * 分页大小改变
     * @param {Number} val - 新的分页大小
     */
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },

    /**
     * 当前页改变
     * @param {Number} val - 新的当前页
     */
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
